



















import { defineComponent } from '@vue/composition-api';

const FlexCompanyMetric = defineComponent({
  props: {
    icon: {},
    name: {},
    usedDisplay: {},
    limitDisplay: {},
    used: {
      type: [String, Number],
      default: 0,
    },
    limit: {
      type: [String, Number],
      default: 0,
    },
  },
  // setup() {},
});

export default FlexCompanyMetric;
